import React, { FunctionComponent } from 'react'
import styled from 'styled-components'
import { GQLShopFieldsContentsSection1Layout, GQLShopFieldsContentsSection2Layout } from '../generated/graphql'

const Outer = styled.div`
  
`

const Title1 = styled.div`
font-size: 1.125rem;
line-height: 1.6666666666666667;
letter-spacing: 0.02em;
color: var(--blue);
margin-top: 2rem;
font-weight: 700;
@media (max-width: 40rem){
  font-size: 1.0625rem;
line-height: 1.4705882352941178;
margin-top: 1.25rem;
}
  
`
const Title2 = styled(Title1)`
  padding: 1.1875rem 0;
  border-top: 1px solid #C1C1C1;
  border-bottom: 1px solid #C1C1C1;
  margin-top: 4.25rem;
  @media (max-width: 40rem){
    padding-top: 1.3125rem;
    padding-bottom: 1.3125rem;
  }
`

const Text = styled.div`
  font-size: 0.875rem;
line-height: 1.9285714285714286;
margin-top: 1.75rem;
@media (max-width: 40rem){
  margin-top: 0.9375rem;
  font-size: 0.875rem;
line-height: 1.7857142857142858;
}
`

type ShopSection1Props = {
  data: DeepPartial<GQLShopFieldsContentsSection1Layout>
}
export const ShopSection1: FunctionComponent<ShopSection1Props> = ({data}) => {
  return <Outer>
    <Title1 dangerouslySetInnerHTML={{__html: data.head ?? ''}} />
    <Text dangerouslySetInnerHTML={{__html: data.text ?? ''}} />
  </Outer>
}
type ShopSection2Props = {
  data: DeepPartial<GQLShopFieldsContentsSection2Layout>
}
export const ShopSection2: FunctionComponent<ShopSection2Props> = ({data}) => {
  return <Outer>
    <Title2 dangerouslySetInnerHTML={{__html: data.head ?? ''}} />
    <Text dangerouslySetInnerHTML={{__html: data.text ?? ''}} />
  </Outer>
}
